import { configureStore } from '@reduxjs/toolkit'
import storeReducer from './storeSlice'
import shiftsReducer from './shiftsSlice'
import authReducer from '@/features/Authentication/authSlice'
import darkModeReducer from './nightModeSlice'
import restaurantReducer from './restaurantSlice'
import fulfillmentModeReducer from './fulfillmentModeSlice'
import theamReducer from './theamSlice'

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const store = configureStore({
  reducer: {
    store: storeReducer,
    shifts: shiftsReducer,
    auth: authReducer,
    darkMode: darkModeReducer,
    restaurant: restaurantReducer,
    fulfillmentMode: fulfillmentModeReducer,
    theam: theamReducer,
  },
})